<style>
  .message-count-unread {
    font-size: 10px;
    color: #fff;
    background: #FB4338;
    border-radius: 40px;
    height: 15px;
    line-height: 7px;
    text-align: center;
    min-width: 15px;
    padding: 5px;
  }

  .message-count-byme {
    font-size: 10px;
    color: #fff;
    background: #26C485;
    border-radius: 40px;
    height: 15px;
    line-height: 7px;
    text-align: center;
    min-width: 15px;
    /*padding: 5px;*/
  }

  .message-count-read {
    font-size: 10px;
    color: #fff;
    background: #D8D8D8;
    border-radius: 40px;
    height: 15px;
    line-height: 7px;
    text-align: center;
    min-width: 15px;
  }

  .msg-wrap {
    position: relative;
  }

    .msg-wrap .msg {
      padding: 0;
      line-height: 0;
      height: 20px;
      min-width: 20px;
      height: 20px !important;
      border-radius: 100% !important;
      line-height: 15px;
      position: absolute;
      right: -7px;
      border: 3px solid #fff;
      top: -8px;
    }
</style>
<div class="floatinghead floatinghead-xs clearfix">
  <div *ngIf="user && ((this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin)|| this.authService.IsUserRole(this.authService.UserRole.SuperAdmin)))" class="btn-group right-btn rightdropdown" dropdown>
    <button id="button-basic" dropdownToggle type="button" class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15 margin-top-20 dropdown-toggle"
            aria-controls="dropdown-basic">
      Share
    </button>
    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
        role="menu" aria-labelledby="button-basic">
      <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareListing(ShareListing,'panlestyle');">Share Listings</a></li>
      <li role="menuitem"><a class="dropdown-item" href="javascript:void(0);" (click)="openModalForShareOM(ShareOM,'portfolio-bov-modal shareom-document-modal');">Share OM</a></li>
    </ul>
  </div>
  <!--<button class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15 margin-top-20" *ngIf="user && ((this.authService.IsUserRole(this.authService.UserRole.Broker) || this.authService.IsUserRole(this.authService.UserRole.Admin)))" (click)="openModalForShareListing(ShareListing,'panlestyle');">Share Listings</button>-->
  <button class="right-btn btn-border margin-right-10 btn adduserbtn margin-bottom-15 margin-top-20" *ngIf="user && ((this.authService.IsUserRole(this.authService.UserRole.Broker)) && !isPropertyForSale)" (click)="openModalForSuggestProperty(SuggestProperties,'panlestyle');">Suggest Properties</button>
  <div class="right margin-right-10 margin-bottom-15 margin-top-20">
    <p style="margin: 10px 0 0 15px" class="selected-rows-count pull-left be-tag-01" *ngIf="selectedRows?.length > 0">
      {{selectedRows?.length}} row{{selectedRows?.length == 1 ? '':'s'}} selected
      <a class="remove" tooltip="Remove Selection" href="javascript:void(0);" (click)="resetSelectedRows();"><i class="icofont icofont-close" aria-hidden="true"></i></a>
    </p>
  </div>
  <div class="rightside clearfix">
    <div class="select-dropdown multiselectdesign margin-right-15 multi-check-dropdown pull-right" style="width:200px !important;">
      <!-- <angular2-multiselect [data]="tableColumns" [(ngModel)]="selectedColumns" name="selectedColumns" [settings]="defaultTypeSettings" (ngModelChange)="onChange($event);"></angular2-multiselect> -->
      <mat-form-field>
        <mat-select placeholder="Select Columns" [(ngModel)]="selectedColumns" (ngModelChange)="onChange($event)" multiple>
          <mat-select-trigger>
            <span>Select Columns</span>
          </mat-select-trigger>
          @for (column of tableColumns; track column) {
          <mat-option [value]="column.id" class="multi-dropdown-item">{{column.name}}</mat-option>
          }
          @if (tableColumns.length === 0) {
          <mat-option class="matoptionnodata" disabled>
            Nothing found...
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="table-responsive">
  <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
    <colgroup>
      <col style="width:50px">
      <col style="width:130px" [hidden]="!actionHeadDisable">
      <col style="width:60px">
      <col style="width:220px !important;">
      <col [hidden]="hideColumn(13)">
      <col [hidden]="!enableMessage" width="50">
      <col [hidden]="hideColumn(1)">
      <col [hidden]="hideColumn(2)">
      <col [hidden]="hideColumn(3)">
      <col [hidden]="hideColumn(4)" style="min-width:120px">
      <col [hidden]="hideColumn(5)">
      <col [hidden]="hideColumn(6)">
      <col [hidden]="hideColumn(7)">
      <col [hidden]="hideColumn(8)">
      <col [hidden]="hideColumn(9)">
      <col [hidden]="!authService.Broker()" style="width:120px">
      <col [hidden]="hideColumn(10)">
      <col [hidden]="hideColumn(11)">

      <col [hidden]="hideColumn(12)">
    </colgroup>
    <thead>
      <tr>
        <!--<th class="actionHeader" [hidden]="showAddToExchange || showAddToFav">Action</th>-->
        <th [hidden]="user == null || !(this.authService.IsUserRole(this.authService.UserRole.Admin) ||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker))" data-orderable="false">
          <label class="custom-checkbox withoutlabel">
            <input type="checkbox" [(ngModel)]="selectAll" (change)="onSelectAll($event);" class="ng-pristine ng-valid ng-touched"><i></i>
          </label>
        </th>
        <th [hidden]="!actionHeadDisable" class="remove sorting_disabled" data-orderable="false">Action</th>
        <!--hidden-xs class for hind td on smaller devices-->
        <th class="remove hidden-xs" style="cursor:auto" data-orderable="false"></th>
        <th [hidden]="true">Property Id</th>
        <th class="property-name-column sticky-left" style="z-index:101">Tenant Name</th>

        <!--<th>Add to Favourites</th>
        <th>Add to 1031 Exchange</th>-->
        <th [hidden]="isPropertyForSale" data-orderable="false">OM</th>
        <th class="remove" style="position:static; cursor:auto;" data-orderable="false"></th>
        <th [hidden]="hideColumn(1)">State</th>
        <th [hidden]="hideColumn(2)" style="min-width:90px;">City</th>
        <th [hidden]="hideColumn(3)">Property Type</th>
        <!--<th>Property Status</th>-->
        <th [hidden]="hideColumn(4)">Status</th>
        <th [hidden]="hideColumn(5)">Asking Price</th>
        <th [hidden]="hideColumn(6)">Rent NOI</th>
        <th [hidden]="hideColumn(7)">Credit Rating</th>
        <th [hidden]="hideColumn(8)" class="whitespacenowrap">Cap Rate</th>
        <!--<th [hidden]="!isPropertyForSale">Remaining Term</th>-->
        <th [hidden]="hideColumn(9)">Remaining Term</th>
        <th [hidden]="!authService.Broker()" style="min-width:120px">Date On Market</th>
        <th [hidden]="hideColumn(10)">Lease Structure</th>
        <th [hidden]="hideColumn(11)" class="whitespacenowrap">Area (SQ FT)</th>

        <th [hidden]="hideColumn(12)">Rank</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let prop of propertiesEx; let i=index">
        <!--[ngClass]="{selectedRow: i === selectedIndex}"-->
        <tr (click)="selecteRow(i)" [class]="this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) ? (prop.IsViewed == 0 ? 'unvisited':'visited'): '' " [class.portfoio-list]="prop.IsPortfolio">
          <td class="first-td" *ngIf="!(user == null || !(this.authService.IsUserRole(this.authService.UserRole.Admin)||this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker)))" data-orderable="false" width="50">
            <label class="custom-checkbox withoutlabel">
              <input type="checkbox" [(ngModel)]="prop.IsSelected" (change)="onCheckboxChange($event,prop.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
            </label>
          </td>
          <td *ngIf="showAddToExchange || showAddToFav" class="whitespacenowrap first-td" [hidden]="!actionHeadDisable">
            <div *ngIf="!showDisLike">
              <a triggers="hover" href="javascript:void(0);" *ngIf="showAddToFav" [ngClass]="{'favlinkintable':(prop.IsFav === 0),'favlinkintableactive':(prop.IsFav === 1)}" tooltip="{{prop.IsFav == 1 ? 'Remove from Favorites':'Add to Favorites'}}" placement="top" container="body" (click)="addToFav(prop.Id);"><i class="fa fa-heart-o icon"></i></a>
              <a class="favlinkintable" href="javascript:void(0);" *ngIf="showAddToExchange" tooltip="Suggest Property" triggers="hover" placement="top" container="body" (click)="open1031ExchangeModal(template1031,'panlestyle',prop);">
                <i class="fa fa-plus-circle icon" aria-hidden="true"></i>
              </a>
            </div>
            <div *ngIf="showDisLike">
              <a *ngIf="prop.IsDisliked != 1" triggers="hover" href="javascript:void(0);" [ngClass]="{'favlinkintable':(prop.IsFav === 0),'favlinkintableactive':(prop.IsFav === 1)}" [class]="classToBind" tooltip="{{prop.IsFav == 1 ? 'Remove from Favorites':'Add to Favorites'}}" placement="top" container="body" (click)="addToFav(prop.Id);">
                <!--<i class="fa fa-heart icon"></i>-->
                <i class="fa fa-heart-o icon"></i>
              </a>
              <a *ngIf="prop.PropertyFor != 602 && showAddToExchange" class="favlinkintable" href="javascript:void(0);" triggers="hover" [ngClass]="{'favlinkintable': (prop.Is1031Exchange === 0), 'favlinkintableactive': (prop.Is1031Exchange === 1)}"
                 [class]="classToBind1031" [tooltip]="prop.Is1031Exchange === 0 ? 'Add To Portfolio': 'Change Portfolio'" placement="top" container="body" (click)="open1031ExchangeModal(template1031,'panlestyle',prop);">
                <i class="fa fa-plus-circle icon" aria-hidden="true"></i>
              </a>
              <a *ngIf="prop.IsFav != 1 && prop.PropertyForId == 602" triggers="hover" href="javascript:void(0);" [ngClass]="{'showDisLike && favlinkintable':(prop.IsDisliked === 0),'favlinkintableactive':(prop.IsDisliked === 1)}" [class]="classToBindDislike" tooltip="{{prop.IsDisliked == 1 ? 'Remove from Disliked list':'Dislike'}}" placement="top" container="body" (click)="addToDisliked(prop.Id);">
                <i class="fa fa-thumbs-o-down icon"></i>
              </a>
            </div>
          </td>
          <!--hidden-xs class for hind td on smaller devices-->
          <td style="position:relative;" class="pro-img-td hidden-xs">

            <a *ngIf="isUserLoggedIn || prop.Slug" href="javascript:void(0);" (click)="onViewProperty(prop.Slug ? prop.Slug : prop.Guid)" [ngClass]="{'be-list': (prop.PropertyForId == 601 && isPropertyForSale == false)}">

              <div class="property-image portfolio-img" *ngIf="prop.IsPortfolio">
                <ng-container *ngIf="prop.PortfolioProperties && prop.PortfolioProperties.length == 0">
                  <img src="assets/img/default-property_1.png" />
                </ng-container>
                <ng-container *ngIf="prop.IsPortfolio && prop.PortfolioProperties && prop.PortfolioProperties.length > 0">
                  <ng-container *ngFor="let image of prop.PortfolioProperties;  let im=index">
                    <img *ngIf="im < 1" [src]="prop.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                    <img *ngIf="im < 3" [src]="image.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                  </ng-container>
                </ng-container>
              </div>
              <div class="property-image" *ngIf="!prop.IsPortfolio">
                <img [src]="prop.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
              </div>
            </a>
            <a *ngIf="!isUserLoggedIn && !prop.Slug" href="/viewproperty/{{prop.Slug}}" [ngClass]="{'be-list': (prop.PropertyForId == 601 && isPropertyForSale == false)}">

              <div class="property-image portfolio-img" *ngIf="prop.IsPortfolio">
                <ng-container *ngIf="prop.PortfolioProperties && prop.PortfolioProperties.length == 0">
                  <img src="assets/img/default-property_1.png" />
                </ng-container>
                <ng-container *ngIf="prop.IsPortfolio && prop.PortfolioProperties && prop.PortfolioProperties.length > 0">
                  <ng-container *ngFor="let image of prop.PortfolioProperties;  let im=index">
                    <img *ngIf="im < 3" [src]="image.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
                  </ng-container>
                </ng-container>
              </div>
              <div class="property-image" *ngIf="!prop.IsPortfolio">
                <img [src]="prop.FilePath" placement="top" onerror="this.onerror=null;this.src='assets/img/default-property_1.png'" />
              </div>
            </a>
          </td>
          <td class="sticky-left" [hidden]="true">
            <p class="d-flex">
              {{ prop.PropertySequenceId }}
            </p>

          </td>
          <!--<td><a href="#" routerLink="/viewproperty/{{prop.Guid}}"><img class="property-image" src="{{prop.FilePath != null ? prop.FilePath : 'assets/img/default-property_1.png'}}" /></a></td>-->
          <td class="sticky-left">
            <p class="d-flex">
              <span *ngIf="prop.IsPortfolio" (click)="showPortfolioProperties(prop.Id, i)" class="btn-collapse" [class.span-open]="this.propertiesEx[i].ShowPortfolioProperties">
                <i class="fa fa-angle-right" aria-hidden="true"></i>
              </span>
              <a *ngIf="isUserLoggedIn || !prop.Slug" href="javascript:void(0);" (click)="onViewProperty(prop.Slug ? prop.Slug : prop.Guid)">{{ prop.PropertyName }}</a>
              <a *ngIf="!isUserLoggedIn && prop.Slug" href="/viewproperty/{{prop.Slug}}">{{ prop.PropertyName }}</a>

            </p> <sub>{{prop.PropertySequenceId}}</sub>

          </td>

          <!--<td><p><a href="javascript:void(0);" [ngClass]="{'favClicked':(prop.IsFav === 1)}"  tooltip="Add to favourite" placement="left" (click)="addToFav(prop.Id);"><i class="fa fa-heart icon"></i></a></p></td>
  <td><p><a href="javascript:void(0);" [ngClass]="{'label1031-checked':(prop.Is1031Exchange === 1)}" tooltip="Add to 1031Exchange" placement="left" (click)="open1031ExchangeModal(template1031,'panlestyle',prop.Id);">
      <i class="fa fa-plus-circle icon" aria-hidden="true"></i></a></p></td>-->
          <td *ngIf="!isPropertyForSale">
            <span *ngIf="prop.OMFilePath == null">-</span>

            <a *ngIf="prop.OMFilePath !=='NOACCESS'" href={{prop.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(prop.OMFilePath!=null)}"><i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}</a>
            <a *ngIf="prop.OMFilePath ==='NOACCESS'" href="#" routerLink="/viewproperty/{{prop.Slug ? prop.Slug : prop.Guid}}" (click)="onRedirection();" [queryParams]="{ prevroute:'Property List',tab:'Memorandom', link:router.url}" [ngClass]="{'border-link':(prop.OMFilePath!=null)}"><i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}</a>



            <!--<a *ngIf="prop.OMFilePath!=null" href={{prop.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(prop.OMFilePath!=null)}">
        <i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}
    </a>-->
          </td>
          <td>
            <div class="msg-wrap" *ngIf="(prop.HasOpenedExchange && authService.Principal1031())
                             || (!authService.Principal1031() && enableMessage)
                             || (authService.Seller() && authService.IsUserRole(this.authService.UserRole.Principal1031) && prop.HasOpenedExchange)
                             || (authService.Seller() && prop.IsLoggedInSellerProperty)">

              <sup class="message-count-unread msg" title="Unread" *ngIf="prop.UnReadMessageCount > 0 && !prop.IsSendByMe"> {{prop.UnReadMessageCount}} </sup>
              <sup class="message-count-byme msg" title="Delivered" *ngIf="prop.IsSendByMe">  </sup>
              <sup class="message-count-read msg" title="No new message" *ngIf="prop.UnReadMessageCount == 0 && !prop.IsSendByMe && prop.IsGroupCreated"> </sup>
              <a class="blueone" (click)="openMessageTab(templateMessageTab,'panlestyle messagepanel',prop)"><i class="icon-chat icon"></i></a>
            </div>
          </td>
          <td [hidden]="hideColumn(1)" class="whitespacenowrap"><p>{{ prop.State ? prop.State : '-' }}</p></td>
          <td [hidden]="hideColumn(2)" class="whitespacenowrap"><p>{{ prop.City ? prop.City : '-' }}</p></td>
          <td [hidden]="hideColumn(3)"><p placement="bottom" tooltip="{{prop.AssetType? prop.AssetType : '-'}}">{{ prop.AssetType ? _commonService.GetPropertyTypeWithCount(prop.AssetType) : '-' }}</p></td>
          <td [hidden]="hideColumn(4)"><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract','not-available':prop.PropertyStatus === 'Not Available','Off-Market':prop.PropertyStatus === 'Off-Market'}">{{ prop.PropertyStatus }}</p></td>
          <td [hidden]="hideColumn(5)" *ngIf="prop.Unpriced"> <p class="whitespacenowrap">Unpriced</p></td>
          <td [hidden]="hideColumn(5)" *ngIf="!prop.Unpriced"><p class="whitespacenowrap">{{(prop.Price!=null&&prop.Price>=0&& prop.IsShowPrice) ? '$ '+(prop.Price |number:0) : '-'}}</p></td>
          <td [hidden]="hideColumn(6)"><p class="whitespacenowrap">{{ (prop.RentNOI) ? '$ '+(prop.RentNOI | number:0) : '-' }}</p></td>

          <!--<td><p>{{  (prop.Rating ? ' (' + prop.Rating + ')' : '') : '-' }}</p></td>-->
          <td [hidden]="hideColumn(7)"><p>{{ prop.Rating ? prop.Rating : '-' }}</p></td>
          <td [hidden]="hideColumn(8)">
            <p *ngIf="prop.capRateText == 'ZCF'">{{prop.capRateText}}</p>
            <p *ngIf="prop.capRateText != 'ZCF'">{{ (prop.CapRate && prop.IsShowPrice) ? (prop.CapRate | number : '1.2-2') + '%' : '-'}}</p>
          </td>
          <!--<td *ngIf="prop.PropertyFor == '601'"><p class="whitespacenowrap">{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>-->
          <!--<td><p class="whitespacenowrap">{{ prop.PortfolioRemainingLeaseTerm ? (prop.PortfolioRemainingLeaseTerm) : '-'}}</p></td>-->
          <td [hidden]="hideColumn(9)"><p class="whitespacenowrap">{{ !prop.IsPortfolio ? (prop.Remaining_Term ? (prop.Remaining_Term) : '-') : (prop.PortfolioRemainingLeaseTerm ? (prop.PortfolioRemainingLeaseTerm) : '-')}}</p></td>
          <td [hidden]="!authService.Broker()" style="min-width:120px">

            <p> {{prop.DateOnMarket ? (_ValidationService.convertUTCDateToLocalDate(prop.DateOnMarket)| date:'MM/dd/yyyy') :'-'}}</p>
          </td>
          <td [hidden]="hideColumn(10)"><p class="whitespacenowrap">{{ prop.LeaseStructure ? prop.LeaseStructure : '-'}}</p></td>
          <td [hidden]="hideColumn(11)"><p>{{ prop.BuildingSize ? (prop.BuildingSize |number:0) : '-' }}</p></td>

          <td [hidden]="hideColumn(12)"><p>{{ prop.Rank }}</p></td>
        </tr>
        <ng-container *ngIf="prop.IsPortfolio && this.propertiesEx[i].ShowPortfolioProperties">

          <tr *ngFor="let propChild of prop.PortfolioProperties; let k=index" (click)="selecteRow(k)" [class]="this.authService.IsUserRole(this.authService.UserRole.Principal) || this.authService.IsUserRole(this.authService.UserRole.Principal1031) ? (prop.IsViewed == 0 ? 'unvisited':'visited'): '' " [class.tr-collapse]="this.propertiesEx[i].ShowPortfolioProperties">
            <td *ngIf="!(user == null || !(this.authService.IsUserRole(this.authService.UserRole.Admin)|| this.authService.IsUserRole(this.authService.UserRole.SuperAdmin) || this.authService.IsUserRole(this.authService.UserRole.Broker)))" data-orderable="false" width="50">
              <!--<label class="custom-checkbox withoutlabel">
                  <input type="checkbox" [(ngModel)]="prop.IsSelected" (change)="onCheckboxChange($event,prop.Id);" class="ng-pristine ng-valid ng-touched"><i></i>
              </label>-->
              <!--<img src="assets/img/connected-arrow.png" class="connection-icon"/>-->
            </td>
            <td *ngIf="showAddToExchange || showAddToFav" class="whitespacenowrap">
              <!--<div *ngIf="!showDisLike">
                  <a triggers="hover" href="javascript:void(0);" *ngIf="showAddToFav" [ngClass]="{'favlinkintable':(propChild.IsFav === 0),'favlinkintableactive':(propChild.IsFav === 1)}" tooltip="{{propChild.IsFav == 1 ? 'Remove from Favorites':'Add to Favorites'}}" placement="top" container="body" (click)="addToFav(propChild.Id);"><i class="fa fa-star-o icon"></i></a>
                  <a class="favlinkintable" href="javascript:void(0);" *ngIf="showAddToExchange" tooltip="Add To Portfolio" triggers="hover" placement="top" container="body" (click)="open1031ExchangeModal(template1031,'panlestyle',prop);">
                      <i class="fa fa-plus-circle icon" aria-hidden="true"></i>
                  </a>
              </div>
              <div *ngIf="showDisLike">
                  <a *ngIf="propChild.IsDisliked != 1" triggers="hover" href="javascript:void(0);" [ngClass]="{'favlinkintable':(propChild.IsFav === 0),'favlinkintableactive':(propChild.IsFav === 1)}" [class]="classToBind" tooltip="{{propChild.IsFav == 1 ? 'Remove from Favorites':'Add to Favorites'}}" placement="top" container="body" (click)="addToFav(propChild.Id);">
                      <i class="fa fa-star-o icon"></i>
                  </a>
                  <a *ngIf="propChild.PropertyFor != 602 && showAddToExchange" class="favlinkintable" href="javascript:void(0);" triggers="hover" [ngClass]="{'favlinkintable': (propChild.Is1031Exchange === 0), 'favlinkintableactive': (propChild.Is1031Exchange === 1)}"
                     [class]="classToBind1031" [tooltip]="propChild.Is1031Exchange === 0 ? 'Add To Portfolio': 'Change Portfolio'" placement="top" container="body" (click)="open1031ExchangeModal(template1031,'panlestyle',prop);">
                      <i class="fa fa-plus-circle icon" aria-hidden="true"></i>
                  </a>
                  <a *ngIf="propChild.IsFav != 1 && propChild.PropertyForId == 602" triggers="hover" href="javascript:void(0);" [ngClass]="{'showDisLike && favlinkintable':(propChild.IsDisliked === 0),'favlinkintableactive':(propChild.IsDisliked === 1)}" [class]="classToBindDislike" tooltip="{{propChild.IsDisliked == 1 ? 'Remove from Disliked list':'Dislike'}}" placement="top" container="body" (click)="addToDisliked(propChild.Id);">
                      <i class="fa fa-thumbs-o-down icon"></i>
                  </a>
              </div>-->
            </td>
            <td style="position:relative;" class="pro-img-td hidden-xs">
              <a *ngIf="isUserLoggedIn || !propChild.Slug" href="javascript:void(0);" (click)="onViewProperty(propChild.Guid)" [ngClass]="{'be-list': (propChild.PropertyForId == 601 && isPropertyForSale == false)}">
                <div class="property-image" *ngIf="propChild.FilePath !=null" [ngStyle]="{'background-image': 'url(' + propChild.FilePath + ')'}"></div>
                <div class="property-image" *ngIf="propChild.FilePath == null" style="background-image:url(../../assets/img/default-property_1.png)"></div>
              </a>
              <a *ngIf="!isUserLoggedIn && propChild.Slug" href="/viewproperty/{{propChild.Slug}}" [ngClass]="{'be-list': (propChild.PropertyForId == 601 && isPropertyForSale == false)}">
                <div class="property-image" *ngIf="propChild.FilePath !=null" [ngStyle]="{'background-image': 'url(' + propChild.FilePath + ')'}"></div>
                <div class="property-image" *ngIf="propChild.FilePath == null" style="background-image:url(../../assets/img/default-property_1.png)"></div>
              </a>
            </td>
            <td class="sticky-left" [hidden]="true">
              <p class="d-flex">
                {{ propChild.PropertySequenceId }}
              </p>

            </td>
            <td class="sticky-left">
              <p>
                <a *ngIf="isUserLoggedIn || !propChild.Slug" href="javascript:void(0);" (click)="onViewProperty(propChild.Guid)">{{ propChild.PropertyName }}</a>
                <a *ngIf="!isUserLoggedIn && propChild.Slug" href="/viewproperty/{{propChild.Slug}}">{{ propChild.PropertyName }}</a>
              </p>
              <sub>{{ propChild.PropertySequenceId }}</sub>
            </td>

            <td *ngIf="!isPropertyForSale">
              <span *ngIf="propChild.OMFilePath == null">-</span>

              <a *ngIf="propChild.OMFilePath !=='NOACCESS'" href={{propChild.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(propChild.OMFilePath!=null)}"><i *ngIf="propChild.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{propChild.OMFilePath!=null?'OM':'-'}}</a>
              <a *ngIf="propChild.OMFilePath ==='NOACCESS'" href="#" routerLink="/viewproperty/{{propChild.Guid}}" (click)="onRedirection();" [queryParams]="{ prevroute:'Property List',tab:'Memorandom', link:router.url}" [ngClass]="{'border-link':(propChild.OMFilePath!=null)}"><i *ngIf="propChild.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{propChild.OMFilePath!=null?'OM':'-'}}</a>
            </td>
            <td></td>
            <td [hidden]="hideColumn(1)"><p>{{ propChild.State ? propChild.State : '-' }}</p></td>
            <td [hidden]="hideColumn(2)"><p>{{ propChild.City ? propChild.City : '-' }}</p></td>
            <td [hidden]="hideColumn(3)"><p tooltip="{{propChild.AssetType? propChild.AssetType : '-'}}">{{ propChild.AssetType ? _commonService.GetPropertyTypeWithCount(propChild.AssetType) : '-' }}</p></td>
            <td [hidden]="hideColumn(4)"><p [ngClass]="{'redtextlabel':(propChild.PropertyStatus === 'Closed' || propChild.PropertyStatus === 'Sold'),'greentextlabel':propChild.PropertyStatus === 'Available','orangetextlabel':propChild.PropertyStatus === 'Under Contract','not-available':propChild.PropertyStatus === 'Not Available','Off-Market':propChild.PropertyStatus === 'Off-Market'}">{{ propChild.PropertyStatus }}</p></td>
            <td [hidden]="hideColumn(5)"><p class="whitespacenowrap">{{(propChild.Price!=null&&propChild.Price>=0 && propChild.IsShowPrice) ? '$ '+(propChild.Price |number:0) : '-'}}</p></td>
            <td [hidden]="hideColumn(6)"><p class="whitespacenowrap">{{ (propChild.RentNOI) ? '$ '+(propChild.RentNOI | number:0) : '-' }}</p></td>
            <td [hidden]="hideColumn(7)"><p>{{ propChild.Rating ? propChild.Rating : '-' }}</p></td>
            <td *ngIf="!propChild.CharacteristicsId" [hidden]="hideColumn(8)"><p>{{ (propChild.CapRate && propChild.IsShowPrice) ? (propChild.CapRate | number : '1.2-2') + '%' : '-'}}</p></td>
            <td *ngIf="propChild.CharacteristicsId" [hidden]="hideColumn(8)"><p>ZCF</p></td>
            <td [hidden]="hideColumn(9)"><p class="whitespacenowrap">{{ propChild.RemainingTerm ? (propChild.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>
            <td [hidden]="!authService.Broker()" style="min-width:120px">

              <p> {{propChild.DateOnMarket ? (_ValidationService.convertUTCDateToLocalDate(propChild.DateOnMarket)| date:'MM/dd/yyyy') :'-'}}</p>
            </td>
            <td [hidden]="hideColumn(10)"><p class="whitespacenowrap">{{ propChild.LeaseStructure ? propChild.LeaseStructure : '-'}}</p></td>
            <td [hidden]="hideColumn(11)"><p>{{ propChild.BuildingSize ? (propChild.BuildingSize |number:0) : '-' }}</p></td>
            <td [hidden]="hideColumn(12)"><p>{{ propChild.Rank }}</p></td>
          </tr>
          <tr class="tr-gap">
            <td colspan="12"></td>
          </tr>

        </ng-container>
      </ng-container>
    </tbody>
    <tfoot>
      <tr *ngIf="propertiesEx?.length == 0&&!IsLoading">
        <td colspan="16" class="no-data-available">
          <div class="nodata">
            <i class="fa fa-exclamation-triangle icon"></i>
            <p>No Data Available</p>
          </div>
        </td>
      </tr>
    </tfoot>
  </table>
</div>

<ng-template #template1031 class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Suggest Property</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">1031 Exchange</label>
      <label class="select">
        <select class="form-control" #state="ngModel" [(ngModel)]="addTo1031Exchange.Exchange1031Id">
          <option value="0">--Select--</option>
          <option *ngFor="let item of exchangeCodes" [(ngValue)]="item.Id">{{item.ExchangeCode}}</option>
        </select>
        <i></i>
      </label>
    </div>
    <!--<div class="form-group">
        <label class="form-label">Group</label>
        <label class="select">
            <select class="form-control" #state="ngModel" [(ngModel)]="addTo1031Exchange.Exchange1031GroupId">
                <option value="0">--Select--</option>
                <option *ngFor="let item of groupList" [(ngValue)]="item.id">{{item.description}}</option>
            </select>
            <i></i>
        </label>
    </div>-->
    <div class="text-right">
      <button class="btn btn-default btn-lg" id="closeModal" (click)="modalRef.hide();">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="savePropertyto1031Exchange();">Save</button>
    </div>
  </div>

</ng-template>
<ng-template #templateMessageTab>
  <app-messages-view [propertyGuid]="selectedPropertyGuid" [modalRef]="modalRef"></app-messages-view>
</ng-template>


<ng-template #ShareListing>
  <app-share-group-add [selectedProperties]="selectedProperties" [modalRefShareListing]="modalRefShareListing" (removeProperties)="removeProperty($event)"></app-share-group-add>
                     
</ng-template>

<ng-template #addToExchange>
  <app-add-favorite-exchange [modalRef]="modalRefAddToExchange" [exchangeCodes]="exchangeCodes" (addToExchange)="addToExchangeSave($event)"></app-add-favorite-exchange>
</ng-template>


<ng-template #SuggestProperties>
  <app-suggest-multiple-properties [selectedProperties]="selectedProperties" [modalRefSuggestProperties]="modalRefSuggestProperties" (removeProperties)="removeProperty($event)"></app-suggest-multiple-properties>
</ng-template>

<ng-template #ShareOM>
  <app-share-omdocuments [propertyIds]="sharedOmProperties" [modalRefShareListing]="modalRefOM" (removeProperties)="removeProperty($event)"></app-share-omdocuments>
</ng-template>
